import * as React from 'react'

interface AuthHeadingProps {
    heading: string
    subHeading: string | React.ReactChild
}

export function AuthHeading({ heading, subHeading }: AuthHeadingProps) {
    return (
        <React.Fragment>
            <h1>{heading}</h1>
            <p className='text-lg'>{subHeading}</p>
            <hr />
        </React.Fragment>
    )
}
